

import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./PreviewCoursePopup.css"
import { useSelector } from "react-redux";

import person1WhatYouWillDo2 from "../../../img/person1WhatYouWillDo2.svg";

import contentMan from "../../../img/contentMan.svg";
import {Minus,Activity ,ChevronLeft,ChevronUp,ChevronDown,X,Plus ,Phone,Check,Video,Play,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,BookA,GalleryHorizontal,BadgePlus,Timer,AudioLines,
    FolderHeart, Forward,Earth,ListChecks,Gift,Settings,Aperture,BetweenHorizontalStart,
    ImagePlay,Film,NotepadText,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare  } from 'lucide-react';

  
const PreviewCoursePopup= ()=>{ 
   
   const dispatch = useDispatch();

  
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorTextDirection='left',CursorText) =>
        {
          
          dispatch({type: "CURSORTEXTDIRECTION",payload:CursorTextDirection  });
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          dispatch({type: "CURSORTEXTDIRECTION",payload:""  });
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
      
      ;
      
   const localToken= localStorage.getItem("profile");
  
   const mytoken = useSelector((state)=>state?.user?.user?.token);
 
    
  
    const courseData = useSelector((state)=>state?.course?.course);
    
  
    
     const [closeSidebar,setCloseSidebar]  = useState(false);
 
    const [cardSidebarActive,setCardSidebarActive]  = useState("");
    const [cardSidebarActiveItem,setCardSidebarActiveItem]  = useState("");
   const [deviceWidth,setDeviceWidth] = useState(false);
    const bottomDivRef = useRef(null);
    
    const bottomDivBoxRef = useRef(null);
    const bodyWidthForMobile =useRef(null)
    
    const [isVisible, setIsVisible] = useState(false);
  
    const [divHeight, setDivHeight] = useState(0);
    function formatUnixTimestampToDate(timestamp) {
      // Convert the Unix timestamp (in seconds) to milliseconds
      const date = new Date(timestamp * 1000);
    
      // Extract the day, month, and year
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const year = date.getFullYear();
    
      // Return the formatted date
      return `${day}-${month}-${year}`;
    }

useEffect(() => {
      // setVideoInPlayer(courseData?.CourseVideoLinks!=[]?courseData?.CourseVideoLinks[0]:"")
      if (bodyWidthForMobile.current) {
        let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
          setDeviceWidth(offsetWidth)
      }
      setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // Set state when the div appears
          } else {
            setIsVisible(false); // Reset state if it goes out of view
          }
        },
        {
          root: null, // Observe within the viewport
          threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
        }
      );
  
      if (bottomDivRef.current) {
        observer.observe(bottomDivRef.current);
      }
  
      return () => {
        if (bottomDivRef.current) {
          observer.unobserve(bottomDivRef.current);
        }
      };
    }, [deviceWidth])


    const scrollableDivRef = useRef(null);

    const StarRating = ({ totalStars = 5 }) => {
      const [rating, setRating] = useState(0);
    
      const handleClick = (index) => {
        setRating(index + 1); // Update rating on click
      };
    
      return (
        <div style={{ display: "flex", gap: "2px", justifyContent: "center", alignItems: "center" ,
        marginTop:"-10px"}}>
          {[...Array(totalStars)].map((_, index) => (
            <Star
              key={index}
              filled={index < rating}
              onClick={() => handleClick(index)}
            />
          ))}
        </div>
      );
    };
    
    const Star = ({ filled, onClick }) => (
      <svg
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        // fill={filled ? "gold" : "none"}
        fill="gold"
        stroke="gold"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="16px"
        height="16px"
        style={{ cursor: "pointer", transition: "fill 0.3s ease" }}
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    );


     return(<>
     
  <div className={`preview-outer-all-small ` } >
  <div></div>
  <div className = "ikcraft_login-signup-right-signup"  id="outer-left">

 

<div style={{padding:'5px',fontSize:'18px',color:'#958FDA',textAlign:'center',marginTop:"70px"}} >  

  

  </div>

  </div>

 <div ref={bodyWidthForMobile} className="outer-right" style={{ minHeight:"90vh",overflow:"auto", position:"relative",}} >
 <div className="content-topk"></div> 
   




 {true?
    <div className="coursePreviewAllOuterGrid" style={{ minHeight:"90vh", position:"relative",}} >
      <div>
        <div 
       
        className={`${!isVisible?"fixed-div-th1":"normal-div-last-th1"}  `}
        style={{ textAlign:"left" ,}} // Move the div horizontally
      >
        <div   style={{width:"100px",height:"60px",background:"rgba(255,114,94,1) ",
        borderRadius:"17px",position:"absolute",
        zIndex:"9999", top:"90px",left:"37%",textAlign:"center" ,cursor:"pointer",
        }}>
          <Play strokeWidth={3}  size={35}style={{margin:"13px"}}  color="#fff"/>
        </div>
        <div  style={{cursor:"pointer"}}  className="product-tag-theme1">Difficult </div>
<img  
   className="" src={"https://i.postimg.cc/t4YRDRbd/6390.jpg"} 
        alt="selected Img"
   style={{cursor:"pointer",width:"100%",cursor:"pointer"
    
   }}/>



{/* const [freePaidStatus, setFreePaidStatus] =useState(courseData?.CoursePriceType)
const [CoursePublicNoEnrollment, setCoursePublicNoEnrollment] =useState(courseData?.CoursePublicNoEnrollment)
const [salePrice, setSalePrice] =useState(courseData?.salePrice)
const [regularPrice, setRegularPrice] =useState(courseData?.regularPrice) */}
<div style={{cursor:"pointer"}} onMouseEnter={
            ()=>handleMouseEnter("rgba(255,114,94,1)","#fff","right","Click Here To Set Course Price Or Make It Free/Public ")}
onMouseLeave={handleMouseLeave} onClick={()=>{}}>{true?
<div className="theme1" style={{display: "flex",
    flexDirection: "row"}}>
<div className="theme1" style={{fontSize:"35px",color:"#000"}}> ₹499.00</div>
<div className="theme1 strikethrough" style={{fontSize:"18px",color:"#999"}}>
   ₹1499.00 </div>
   <div className="theme1" style={{fontSize:"13px",color:"#777",marginRight:"15px",float:"right"}}>
    </div>

</div>:<div className="theme1" >
<div className="theme1 " style={{fontSize:"28px",color:"#000"}}>  Free</div>
</div>}
</div>

{
  //for mobile Bottom Card
}
<div  className="BottomCardXsCourse"><div  className="BottomCardXsCourseInn">
{true?
<div className="theme1" style={{}}>
<div className="theme1" style={{fontSize:"26px",color:"#000"}}> ₹499.00</div>
<div className="theme1 strikethrough" style={{fontSize:"14px",color:"#999",marginTop:"-8px"}}>
   ₹1499.00 </div>
   
</div>:<div className="theme1" >
<div className="theme1 " style={{fontSize:"28px",color:"#000"}}>  Free</div>
</div>}
{true?
<div className="theme1"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  <div className="theme1"  style={{margin:"0px"}}>Buy Now</div></div>
  // :courseData?.CoursePublicNoEnrollment=="Yes"?
  // <div className="theme1"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="theme1"  style={{margin:"0px"}}>Start Now</div></div>:
  //    <div className="theme1"  style={{fontSize:"22px",color:"#fff",border:"1px solid #958FDA",
  //   borderRadius:"5px",margin:"13px",textAlign:"center",height:"29px",background:"#958FDA"}}>
  //    <div className="theme1"  style={{margin:"0px"}}>Enrol Now</div></div>
     :""}
  </div></div>

<div >
   {/* {courseData?.CoursePriceType=="Free"&&courseData?.CoursePublicNoEnrollment=="Yes"? <span className="theme1"
      style={{fontSize:"10px",color:"rgba(255,114,94,0.9)",display: "flex",
    flexDirection: "row"}}><Timer  size={22} color="rgba(255,114,94,0.9)"/> 
   <span className="theme1">No Enrollment Required</span></span> :""} */}
 
     {true? <span className="theme1"
      style={{fontSize:"10px",color:"rgba(255,114,94,0.9)",display: "flex",
    flexDirection: "row"}}><Timer  size={22} color="rgba(255,114,94,0.9)"/> 
   <span className="theme1"> </span></span> :""}
 
  </div>
  {true?<div><div className="theme1"  style={{fontSize:"16px",color:"#958FDA",border:"1px solid #958FDA",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px"}}>
  <div className="theme1"  style={{margin:"0px"}}>Add TO Cart</div></div>
  <div className="theme1"  style={{fontSize:"16px",color:"#fff",border:"1px solid #958FDA",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
  <div className="theme1"  style={{margin:"0px"}}>Buy Now</div></div></div>
//   :courseData?.CoursePublicNoEnrollment=="Yes"?
//   <div className="theme1"  style={{fontSize:"16px",color:"#958FDA",border:"1px solid #958FDA",
//     borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px"}}>
//      <div className="theme1"  style={{margin:"0px"}}>Start Now</div></div>:<div className="theme1"  style={{fontSize:"16px",color:"#fff",border:"1px solid #958FDA",
//  borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
//   <div className="theme1"  style={{margin:"0px"}}>Enrol Now</div></div>
  :""}

  <div className="theme1 grid2080Course"  style={{
  border:"2px dashed #f1f1f1",
 borderRadius:"25px",margin:"13px",height:"44px",background:"#fff"}}>
  <div style={{background:"#f1f1f1",width:"50px",height:"50px",borderRadius:"50%",padding:"0px"}} >
  <Gift strokeWidth={2} absoluteStrokeWidth  size={27} style={{margin:"11px"}} color="#444" />  </div>
  <div   >
    <div className="theme1"   style={{margin:"0px",fontSize:"16px",color:"#444"}}>Gift this course</div>
  <div className="theme1"  style={{marginTop:"-13px",fontSize:"12px",color:"#777",fontWeight:"500"}}
  >Send this course as  gift to your friends</div></div></div>
<div style={{padding:"10px"}} ref={bottomDivBoxRef}>
<div   className="theme1 "style={{fontSize:"14px",fontWeight:"bold",color:"#222",padding:"10px"}}> This Course Includes </div>

{/* 
{courseData?.MaterialIncluded?Object.values(courseData?.MaterialIncluded).map((item, index) => 
        (<div style={{cursor:"pointer"}} ><WhatsIncludedSidebarAllData index={index} key={item.id} 
          contentType={item.contentType} no={item.no} id={item.id} totalNumber={item.totalNumber} status={item.status} 
          contentIcon={item.contentIcon}   /></div>)):'' } */}
   


</div>

</div></div>
<div className=" " ><div style={{cursor:"pointer",}} >

<div className="theme1 courseTitleFont">Direct your energy where it counts, stay calm under pressure, and let clarity shape decisive action.
  
 </div>
 </div>
<div className="theme1 courseCat" style={{padding:"15px"}}>In <span className="theme1 catUndrline"> Blender </span></div>

<div className="theme1" style={{display: "flex",
    flexDirection: "row"}}><AudioLines size={26} color="#958FDA" strokeWidth={3} />
<div  onMouseEnter={
            ()=>handleMouseEnter("#fff","#222","","Click Here To Change Course Status")}
onMouseLeave={handleMouseLeave}  onClick={()=>{}} className="theme1 " 
  style={{padding:"15px",fontSize:"17px",color:"#958FDA",fontWeight:"999",cursor:"pointer"}}>
Trending</div>
<StarRating totalStars={5}  /> <div className="theme1"
 style={{padding:"15px",fontSize:"14px",color:"#111",fontWeight:"600"}}>4.5 (459 Ratings)</div>
</div>


<div className="theme1 afterTitleBadgesLeft" style={{}}>
  

<div     className="theme1 " style={{padding:"15px",fontSize:"16px",color:"#111",fontWeight:"999",display: "flex",
    flexDirection: "row",cursor:"pointer"}}>
<Earth size={26} color="rgba(255,114,94,0.9)" strokeWidth={3} /> 
<div  className="theme1 ">Hindi</div></div>
  <div className="theme1"  style={{fontSize:"14px",color:"#fff",border:"1px solid rgba(255,114,94,0.9)",
 borderRadius:"25px",margin:"0px",marginTop:"2px",textAlign:"center",height:"10px",
 background:"rgba(255,114,94,0.9)",cursor:"pointer"}}>
  <div className="theme1"  style={{marginTop:"-3px"}}>Difficult</div></div>
 <div className="theme1"
 style={{padding:"15px",fontSize:"14px",color:"#111",fontWeight:"500"}}>Last Updated On : </div>
 <div  className="theme1">20 Sept 2024</div>
 <div  style={{padding:"15px",fontSize:"16px",color:"#111",fontWeight:"999",display: "flex",
    flexDirection: "row"}}><span  className="theme1 shareWishlistText">Share</span> <Forward style={{marginLeft:"15px"}}strokeWidth={3} absoluteStrokeWidth size={22} color="#555"/>
</div>
<div  style={{padding:"15px",fontSize:"16px",color:"#111",fontWeight:"999",display: "flex",
    flexDirection: "row"}}><span  className="theme1 shareWishlistText">Wishlist </span>
 <FolderHeart style={{marginLeft:"15px"}} strokeWidth={3} absoluteStrokeWidth  size={22} color="#555"/>
 </div>
</div>
<div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#f9f9f9",position:"relative"}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
<img    className="CourseSideStickImg" src={person1WhatYouWillDo2} 
        alt="selected Img"
   style={{cursor:"pointer",
    
   }}/>
</div>
<div className="theme1 courseContentTitleFont">What you'll learn</div>
<div className="theme1 courseWhatWillearnText">
  
      <div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>



  
  </div>
  <div className="theme1 courseWhatWillearnText"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
  
  <div style={{background:"rgba(255,114,94,0.051)",borderRadius:"15px",padding:"10px",margin:"5px"}} >
  <div className="theme1 grid2080Course"  style={{
  borderRadius:"25px",margin:"3px"}}>
  <div style={{background:"rgba(255,114,94,0.9)",width:"56px",height:"56px",borderRadius:"50%",padding:"0px"}} >
  <AlarmSmoke strokeWidth={4} absoluteStrokeWidth  size={40} style={{margin:"8px",marginTop:"10px"}} color="#fff" />  </div>
  <div   >
  </div></div>
<div><div   >
    <div className="theme1"   style={{margin:"0px",fontSize:"26px",color:"rgba(255,114,94,0.9)",fontWeight:"800"}}>Gift this course</div>
  <div className="theme1"  style={{marginTop:"-13px",fontSize:"16px",color:"#444",fontWeight:"600"}}
  >Gift this course to your friends</div>
  
  <div className="theme1"  style={{marginTop:"-13px",fontSize:"12px",color:"#333",fontWeight:"500"}}
  >Now You Can Gift This Course To Your Friend, So That Friendship Lives Longer</div>
  </div>
  <div className="theme1 grid2080Course"  style={{
  border:"2px dashed rgba(144,202,249,0.9)",
 borderRadius:"25px",margin:"13px",height:"44px",background:"#fff"}}>
  <div style={{background:"rgba(144,202,249,0.9)",width:"50px",height:"50px",borderRadius:"50%",padding:"0px"}} >
  <Gift strokeWidth={2} absoluteStrokeWidth  size={27} style={{margin:"11px"}} color="#fff" />  </div>
  <div   >
    <div className="theme1"   style={{margin:"10px",fontSize:"16px",color:"#555",fontWeight:"900"}}>Send As Gift</div>
  <div className="theme1"  style={{marginTop:"-13px",fontSize:"12px",color:"#bbb",fontWeight:"500"}}
  ></div></div></div>
{/* 
 <div className="theme1"  style={{fontSize:"16px",border:"1px solid rgba(144,202,249,0.9)",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#fff"}}>
    <div className="theme1"  style={{margin:"0px",color:"rgba(144,202,249,0.9)"}}>Send As Gift</div>
    </div> */}
    </div>
  </div>
  <div style={{background:"rgba(144,202,249,0.09)",borderRadius:"15px",padding:"10px",margin:"5px"}} >

<div><div   ><div className="theme1"   style={{margin:"0px",fontSize:"26px",color:"#222",fontWeight:"800"}}>
    Get Certificate</div>
 <div align="center">
   {/* <img src={imgCert} alt="imgCert" style={{width:"280px",borderRadius:"15px"}}/> */}
 </div>  
  </div></div>
  </div>
</div>
<div className="theme1"  style={{margin:"10px",marginTop:"10px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
 <div className="theme1 whatIncludesInSidebar courseContentTitleFont "  style={{
  borderRadius:"25px",margin:"3px"}}>
  
  <BellElectric  strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
  
  Highlights
  </div>
  

<div className="theme1 courseWhatWillearnText" style={{
  margin:"5px",marginTop:"5px"}}>
  
      <div   className="courseWhatWillearnIcon ">
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
      <div className="theme1 "
 style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>



  
  </div>

<div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#fff",border:"2px dashed  #90CAF9",position:"relative"}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
<img    className="CourseSideStickImgTw" src={contentMan} 
        alt="selected Img"
   style={{cursor:"pointer",
    
   }}/>
</div>
<div className="theme1 courseContentTitleFontTwo">Course Content</div>
<div className=" ">
<div  className="courseContentItemOuterHeadActive">
        <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div><div className="theme1 "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>
  <ChevronUp strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)"/> 
      </div>
      <div  className="courseContentItemOuter">
      <NotepadText  strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div><div className="theme1 innerContentInfoStyle "
 >3 Attempts</div>
      </div>
      <div  className="courseContentItemOuter">
      <ImagePlay strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div><div className="theme1 innerContentInfoStyle"
 style={{}}>3Min 23Sec</div>
      </div>
      <div  className="courseContentItemOuter">
      <Film strokeWidth={2} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
      <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div><div className="theme1 innerContentInfoStyle"
 style={{}}>See Schedule</div>
      </div>




      <div  className="courseContentItemOuterHeadInActive">
        <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="theme1 "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
  
      </div><div  className="courseContentItemOuterHeadInActive">
        <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="theme1 "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
      </div><div  className="courseContentItemOuterHeadInActive">
        <div className="theme1 "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
   This Course Includes 
 
      </div><div className="theme1 "
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>25% <span className="hidexs">progress</span></div>  
 <ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="#555"/> 
      </div>



</div>
<div className="contentsRemainingButtonOuter">
  <div className="theme1 contentsRemainingButtonOuter"  style={{fontSize:"16px",color:"#fff",
  border:"1px solid #958FDA",fontWeight:"700",
 borderRadius:"5px",margin:"13px",textAlign:"center",height:"20px",background:"#958FDA"}}>
  <Plus  strokeWidth={3}   absoluteStrokeWidth  size={25}  color="#fff"/> <div className="theme1"  style={{margin:"0px"}}> 
    <div  className="theme1" style={{marginTop:"-5px"}}>  6 More Sections</div></div></div>

  </div>
  </div>



<div className="theme1"  style={{margin:"0px",marginTop:"20px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
<div className="theme1 whatIncludesInSidebar FAOuterTitle  "  style={{
  borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:"#222"}}>
  
  <BotMessageSquare   strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
  
  FAQs
  </div>

<div className=" ">
  
<div className="outerFAQShadow">
<div  className="courseFAQActive" >
        <div className="theme1 FAQQuestionStyle"
 > 
 FAQ 1:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"#fff",width:"40px",height:"40px",borderRadius:"50%"}}><Minus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
      </div>

      
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
      </div>
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div>
      <div  className="courseFAQItemInner">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
      <div className="theme1 "
 style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
      </div>


<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 2:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>
      
<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 3:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
       <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>
<div className="outerFAQShadow">
      <div  className="courseFAQInActive">
        <div className="theme1 FAQQuestionStyle "
 style={{}}> 
 FAQ 4:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:"rgba(255,114,94,0.1)",width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/> </div>
    
     
      </div>
     
</div>

</div>

  </div>



</div>
<div>
</div>
</div>:"Please Add Name And Course Details To See Preview"}
<div ref={bottomDivRef} ></div>
<div style={{ height: "500px" ,}} ></div>  





  


   </div>
   
	  </div> 

    </>
                            
   )  
   }
   export default PreviewCoursePopup;